<cam-layout-page>
  <cam-layout-content>
    <cam-layout-not-found></cam-layout-not-found>
  </cam-layout-content>
  <cam-layout-nav>
    <app-menu-main></app-menu-main>
  </cam-layout-nav>
</cam-layout-page>
